
import { paginationProps, getOrDeleteRequest, postOrPutRequest, customSwal, getSession } from '../utils/utils';
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import PreloaderTable from './PreloaderTable';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleMinus, faCirclePlus, faCircleXmark, faDownload, faEdit, faFileAlt, faUndo, faUserCircle, faUserMinus, faUserPlus, faX } from '@fortawesome/free-solid-svg-icons';
import { getRole } from '../utils/utils';
import exportFromJSON from 'export-from-json';
import { useEffect, useState } from 'react';

const DataTableComponent = ({ columns, data, loading, button, buttonPersonalizado, toView, toEdit, toEditReport, toDelete, toDisable, toEnable, toUnverify, toVerify, toRestore, reload, nameTable = 'Datos', toExportReport, toViewReport }) => {
    const role = getRole();

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const tableData = {
        columns,
        data: data.data ?? [],
    };

    useEffect(() => {
        reload(currentPage);
    }, [currentPage]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    useEffect(() => {
        setTotalPages(data.total);
    }, [data]);

    const exportToExcel = () => {
        const dataToExport = data.data.map(row => {
            let rowData = {};
            columns.forEach(column => {
                // console.log(column.selector);
                if (column.selector == 'photo_binary'
                    || column.name == 'Foto de perfil'
                    || column.selector == 'photo'
                    || column.selector == 'image'
                    || column.name == 'Imagen de perfil') return;

                const value = typeof column.selector === "function"
                    ? column.selector(row)
                    : row[column.selector];

                rowData[column.name] = value;
            });
            return rowData;
        });

        dataToExport.forEach(item => {
            Object.keys(item).forEach(key => {
                const newKey = `"${key}"`;
                if (newKey !== key) {
                    item[newKey] = item[key];
                    delete item[key];
                }
            });
        });

        const fileName = `${nameTable}_${new Date().getDate()}-${new Date().getMonth() + 1}-${new Date().getFullYear()}`;
        const exportType = 'csv';

        exportFromJSON({ data: dataToExport, fileName, exportType, withBOM: true });
    }

    const exportToExcelReport = async (e) => {
        let project_id = e.id.split('/')[0];
        let date = e.id.split('/')[1];
        let month = date.split('-')[0];
        let year = date.split('-')[1];

        const response = await getOrDeleteRequest(`${toExportReport}${e.company_id}?project_id=${project_id}&month=${month}&year=${year}`, 'GET');

        if (response.type === 'success' && Array.isArray(response.responses)) {
            const dataToExport = response.responses.reduce((acc, item) => {
                acc[item.question] = item.response;
                return acc;
            }, {});

            Object.keys(dataToExport).forEach(key => {
                const newKey = `"${key}"`;
                if (newKey !== key) {
                    dataToExport[newKey] = dataToExport[key];
                    delete dataToExport[key];
                }
            });

            const fileName = `Reporte_${month}-${year}${e.company?.company_name ? `_${e.company?.company_name}` : ''}${e.company?.trade_name ? `_${e.company?.trade_name}` : ''}`;
            const exportType = 'csv';

            exportFromJSON({ data: [dataToExport], fileName, exportType, withBOM: true });
        } else {
            console.error("Respuesta no válida o sin datos.");
        }
    };

    const restoreUser = async (e) => {
        console.log(e.target.id);
        e.preventDefault();
        customSwal.fire({
            title: '¿Estás seguro?',
            text: "¡No podrás revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, restaurar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                customSwal.fire({
                    title: 'Cargando...',
                    text: 'Por favor espere',
                    allowOutsideClick: false,
                    didOpen: () => {
                        customSwal.showLoading();
                    }
                });
                let response = await postOrPutRequest(
                    `${toRestore}${e.target.id}`,
                    'PUT',
                );
                if (response.type === 'success') {
                    reload && reload();
                    customSwal.fire({
                        title: response.message,
                        icon: 'success',
                        confirmButtonText: 'Aceptar',
                        timer: 3000
                    });
                } else {
                    customSwal.fire({
                        title: response.message,
                        icon: 'error',
                        confirmButtonText: 'Aceptar',
                    });
                }
            }
        });
    };

    const enableOrDisable = async (e, status) => {
        e.preventDefault();
        customSwal.fire({
            title: 'Cargando...',
            text: 'Por favor espere',
            allowOutsideClick: false,
            didOpen: () => {
                customSwal.showLoading();
            }
        });
        let response = await postOrPutRequest(
            `${status == 1 ? toDisable : toEnable}${e.target.id}`,
            'PUT',
        );
        if (response.type === 'success') {
            reload && reload();
            customSwal.fire({
                title: response.message,
                icon: 'success',
                confirmButtonText: 'Aceptar',
                timer: 3000
            });
        } else {
            customSwal.fire({
                title: response.message,
                icon: 'error',
                confirmButtonText: 'Aceptar',
            });
        }
    };

    const verifyOrUnverify = async (e, status) => {
        e.preventDefault();
        customSwal.fire({
            title: 'Cargando...',
            text: 'Por favor espere',
            allowOutsideClick: false,
            didOpen: () => {
                customSwal.showLoading();
            }
        });
        let response = await postOrPutRequest(
            `${status == 1 ? toUnverify : toVerify}${e.target.id}`,
            'PUT',
        );
        if (response.type === 'success') {
            reload && reload();
            customSwal.fire({
                title: response.message,
                icon: 'success',
                confirmButtonText: 'Aceptar',
                timer: 3000
            });
        } else {
            customSwal.fire({
                title: response.message,
                icon: 'error',
                confirmButtonText: 'Aceptar',
            });
        }
    };

    const eliminar = async (e) => {
        console.log(e.target.id);
        e.preventDefault();
        customSwal.fire({
            title: '¿Estás seguro?',
            text: "¡No podrás revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminarlo'
        }).then(async (result) => {
            if (result.isConfirmed) {
                customSwal.fire({
                    title: 'Cargando...',
                    text: 'Por favor espere',
                    allowOutsideClick: false,
                    didOpen: () => {
                        customSwal.showLoading();
                    }
                });
                console.log(`${toDelete}${e.target.id}`);
                let response = await getOrDeleteRequest(
                    `${toDelete}${e.target.id}`,
                    'DELETE',
                );
                if (response.type === 'success') {
                    reload && reload();
                    customSwal.fire({
                        title: response.message,
                        icon: 'success',
                        confirmButtonText: 'Aceptar',
                        timer: 3000
                    });
                } else {
                    customSwal.fire({
                        title: response.message,
                        icon: 'error',
                        confirmButtonText: 'Aceptar',
                    });
                }
            }
        });
    };

    const getReport = async (data) => {
        console.log(data);
        // return
        let session = getSession();

        let id = data.id.split('/')[0];
        let date = data.id.split('/')[1];
        let month = date.split('-')[0];
        let year = date.split('-')[1];

        let uri;

        if ([1, 6].includes(session.type_id)) {
            uri = `reports/export-report/${data.company.user_id}?month=${month}&year=${year}&project_id=${id}`;
        }

        if ([4, 5].includes(session.type_id)) {
            uri = `reports/export-report/${session.type_id === 4 ? session.id : session.company.user_id}?month=${month}&year=${year}&project_id=${id}`;
        }

        window.open(`${process.env.REACT_APP_API_URI}${uri}`, '_blank');
    };

    const expandedComponent = ({ data }) => {

        if (window.location.pathname === '/Usuarios' && data.id === 1) {
            return null;
        }

        return <div className="flex py-2 px-12" role="menu" aria-orientation="vertical" aria-labelledby="dropdown-button">
            {buttonPersonalizado && buttonPersonalizado(data)}
            {toView && <Link
                to={`${toView}${data.id}`}
                className="flex items-center bg-DarkBlue hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-sm bg-turquesa text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2 text-white" icon={faUserCircle} /> Ver
            </Link>}

            {toViewReport && <button
                onClick={() => { getReport(data) }}
                className="flex items-center bg-DarkBlue hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-sm bg-turquesa text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2 text-white" icon={faUserCircle} /> Ver
            </button>}

            {(toExportReport && [1,6,4].includes(role)) && <button
                onClick={() => { exportToExcelReport(data) }}
                className="flex items-center bg-turquesa hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-sm text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2" icon={faFileAlt} /> Exportar CSV
            </button>}

            {/* Solo permitido para usuarios con rol de administrador y editor */}
            {(toEdit && [1, 4, 6].includes(role)) && <Link
                to={`${toEdit}${data.id}`}
                className="flex items-center bg-turquesa hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-sm text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2" icon={faEdit} /> Editar
            </Link>}

            {(toEditReport && [4, 6].includes(role)) && <Link
                to={`${toEditReport}${data.id}`}
                className="flex items-center bg-turquesa hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-sm text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2" icon={faEdit} /> Editar reporte
            </Link>}

            {/* Solo permitido para usuarios con rol de administrador y editor */}
            {(toDisable && [1, 4, 6].includes(role)) && <button
                id={data.id}
                onClick={(e) => { enableOrDisable(e, data.status) }}
                className="flex items-center bg-turquesa hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-sm text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2" icon={
                    data.status === 1
                        ? faUserMinus
                        : faUserPlus
                } /> {data.status === 1 ? 'Desactivar' : 'Activar'}
            </button>}

            {/* Solo permitido para usuarios con rol de administrador y editor */}
            {(toUnverify && [1, 2, 4, 6].includes(role)) && <button
                id={data.id}
                onClick={(e) => { verifyOrUnverify(e, data.verified) }}
                className="flex items-center bg-turquesa hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-sm text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2" icon={
                    data.verified === 1
                        ? faCircleXmark
                        : faCircleCheck
                } /> {data.verified === 1 ? 'Quitar verificación' : 'Verificar'}
            </button>}

            {/* Solo permitido para usuarios con rol de administrador */}
            {(toDelete && toDelete !== 'response/destroy/' && [1, 6].includes(role)) && <button
                id={data.id}
                onClick={(e) => { eliminar(e) }}
                className="flex items-center bg-turquesa hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-sm text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2" icon={faX} /> Eliminar
            </button>}

            {/* Solo permitido para usuarios con rol de administrador */}
            {(toDelete === 'response/destroy/' && [1].includes(role)) && <button
                id={`${data.id}?company_id=${data.company?.id}`}
                onClick={(e) => { eliminar(e) }}
                className="flex items-center bg-turquesa hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-sm text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2" icon={faX} /> Eliminar
            </button>}

            

            {/* Solo permitido para usuarios con rol de administrador */}
            {(toRestore && toRestore !== 'response/restore/' && [1, 6].includes(role)) && <button
                id={data.id}
                onClick={(e) => { restoreUser(e) }}
                className="flex items-center bg-turquesa hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-sm text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2" icon={faUndo} /> Restaurar
            </button>}

            {/* Solo permitido para usuarios con rol de administrador */}
            {(toRestore && toRestore === 'response/restore/' && [1].includes(role)) && <button
                id={`${data.id}?company_id=${data.company?.id}`}
                onClick={(e) => { restoreUser(e) }}
                className="flex items-center bg-turquesa hover:opacity-90 rounded-lg mx-1 px-4 py-2 text-sm text-white cursor-pointer"
            >
                <FontAwesomeIcon className="mr-2" icon={faUndo} /> Restaurar
            </button>}
        </div>
    };

    return (
        <div className='relative'>
            <DataTableExtensions
                {...tableData}
                filterPlaceholder={"Buscar"}
                print={false}
                export={false}
            >
                <DataTable
                    columns={columns}
                    data={!loading && data.data?.length > 0 ? data.data : []}
                    noHeader
                    defaultSortAsc={false}
                    pagination
                    paginationServer
                    paginationTotalRows={data.total}
                    onChangePage={handlePageChange}
                    progressPending={loading}
                    progressComponent={<PreloaderTable />}
                    highlightOnHover
                    paginationComponentOptions={paginationProps}
                    responsive
                    noDataComponent={<span className="font-bold text-black my-5">No hay registros</span>}
                    expandableRows={toView || toEdit || toDelete || toDisable || toEnable || toRestore || buttonPersonalizado || toUnverify || toVerify || toExportReport || toViewReport}
                    expandableRowsComponent={expandedComponent}
                />
            </DataTableExtensions>

            {/* Solo permitido para usuarios con rol de administrador y editor */}
            <div className='absolute top-0 right-0 p-5'>
                {(button && [1, 2, 4, 5, 6].includes(role)) && button}
                <button onClick={exportToExcel} className="bg-turquesa hover:opacity-90 rounded-lg px-4 py-2 mx-1 text-sm text-white cursor-pointer">
                    Exportar CSV <FontAwesomeIcon icon={faDownload} />
                </button>
            </div>
        </div>
    )
}

export default DataTableComponent;
